// BASE_PATH: API base URL from environment variable
// Fallback to empty string if not set (for relative paths)
export const BASE_PATH = process.env.REACT_APP_MY_API_KEY || '';
